module.exports = __webpack_public_path__ + "static/img/11.8e1c86cc.png";